export function date(value) {
  const validDate = value => {
    const parts = value.split('.');
    if (parts.length !== 3) return false;
    if (parts[2].length !== 4) return false;
    const date = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
    return date instanceof Date;
  }
  return {
    valid: !value || validDate(value),
    errorMessage: 'Bitte geben Sie ein valides Datum ein.',
  }
}
